exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-217d58bb]{display:flex;justify-content:center;align-items:center;position:absolute;height:100%;width:100%}.wrap-name[data-v-217d58bb]{display:flex;white-space:nowrap}.wrap-name .intv-name[data-v-217d58bb]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
